import type { SessionInfo } from "@opencode/client/promise"

export function sidebarAttentionPriority(state: {
  needsAttention: () => boolean
  unread: () => boolean
  loading: () => boolean
}) {
  if (state.needsAttention()) return 3
  if (state.unread()) return 2
  return state.loading() ? 1 : 0
}

// A saved pin can need input before the user opens it. Hydrate only its family and request metadata.
export async function loadSidebarSessionMetadata(
  session: {
    sync: (id: string, options?: { children?: boolean }) => Promise<unknown>
    get: (id: string) => SessionInfo | undefined
    family: (id: string) => readonly string[]
    permission: { sync: (id: string) => Promise<unknown> }
    form: { sync: (id: string) => Promise<unknown> }
  },
  id: string,
) {
  await Promise.allSettled([session.sync(id, { children: true })])
  await Promise.allSettled(
    [...new Set([id, ...session.family(id)])].flatMap((member) => [
      session.permission.sync(member),
      session.form.sync(member),
    ]),
  )
  return session.get(id)
}
